export const errorHandler = error => {
  console.log(error);
};
